<div class="mybets-betslip-multi-bet clearfix" [class.betcard-redesign]="myBetsUtilService.isBetCardRedesigned()">
    @if (showIndicator) {
        <div class="mybets-betslip-multi-bet_indicator">
            <ms-my-bets-multi-bet-card-indicator [bet]="bet" [event]="bet.event" [result]="state" />
        </div>
    }
    <div class="mybets-betslip-multi-bet_info" [ngClass]="isEpcotEnabled ? 'epcot-enabled-expanded' : 'epcot-disabled-expanded'">
        @if (bet.needToShowEventView && bet.event) {
            <ms-my-bets-betslip-event-info
                [bet]="bet"
                [event]="bet.event"
                [myBetsListContext]="myBetsListContext"
                [cashedOut]="cashedOut()"
                [cancelledBet]="cancelledBet()"
                [betslip]="betslip">
                @if (!hideOdds || !myBetsUtilService.isBetCardRedesigned()) {
                    <span topright-section class="mybets-betslip-bet-odds">{{ bet.odds | msMyBetsOddsPipe }}</span>
                }
                <ng-template mybets-event-info-betslip-headsection [ngTemplateOutlet]="headSection" />
            </ms-my-bets-betslip-event-info>
        } @else {
            <ms-my-bets-betslip-non-event-info
                [bet]="bet"
                [event]="bet.event"
                [myBetsListContext]="myBetsListContext"
                [cashedOut]="cashedOut()"
                [cancelledBet]="cancelledBet()"
                [betslip]="betslip"
                [shouldApplyPaddings]="false">
                @if (isBOGVisible) {
                    <ms-help-box-badge class="best-odds" [ngClass]="{ bogNotPaidOut: isBOGNotPaidOut }" [boxType]="'bestoddsguarantee'" />
                }
                <span topright-section class="mybets-betslip-bet-odds">{{ bet.odds | msMyBetsOddsPipe }}</span>
                <ng-template mybets-non-event-info-betslip-headsection [ngTemplateOutlet]="headSection" />
            </ms-my-bets-betslip-non-event-info>
        }
    </div>
    @if (isEpcotEnabled && !myBetsUtilService.isBetCardRedesigned()) {
        <div class="mybets-card-divider"></div>
    }
</div>

<ng-template #headSection>
    <ms-my-bets-bet-card-title [betslip]="betslip" [bet]="bet" [myBetsListContext]="myBetsListContext" [showBetOdds]="true">
        <ms-my-bets-betslip-option-name title [bet]="bet" />
        <ms-my-bets-betslip-market-name sub_title [bet]="bet" [betslip]="betslip" [cashedOut]="cashedOut()" [cancelledBet]="cancelledBet()" />
    </ms-my-bets-bet-card-title>
</ng-template>
